import {
  ICreateLotes,
  ICreateTagLote,
  IEditLoteEvento,
  ILotes,
  TagLote,
  ValoresTag,
} from "interfaces/lotes";
import api from "./api";

// LOTE: IMPLEMENTAÇÃO AÇÕES DO LOTE DO EVENTO

// Criar um lote com a tag de um evento
export async function saveLoteEvento(
  eventoId: number,
  lote: ILotes
): Promise<ILotes[]> {
  const newLote: ICreateLotes = {
    eventoId: eventoId,
    dataInicio: lote.dataInicio,
    dataFinal: lote.dataFinal,
    tags: getTags(lote.valoresTags),
  };

  try {
    const response = await api.post("/lotes", newLote);
    if (response.status === 201) {
      const createdEventoId = response.data.eventoId;
      const allLotes = await getAllLotes(createdEventoId);
      return allLotes;
    } else {
      throw new Error("Falha ao criar o lote");
    }
  } catch (error: any) {
    throw new Error(error.message);
  }
}

function getTags(lote: ValoresTag[]) {
  return lote.map((item) => {
    return { tagId: item.id, valor: Number(item.valor) };
  });
}

// Excluir um lote e as tags do evento
export async function deleteLote(loteId: number) {
  try {
    const response = await api.delete(`/lotes/${loteId}`);
    const eventoId = response.data.eventoId;
    const allLotes = await getAllLotes(eventoId);
    return allLotes;
  } catch (error) {
    throw new Error("Falha na comunicação com o servidor");
  }
}

// Buscar todos os lotes do evento
export async function getAllLotes(eventoId: number): Promise<ILotes[]> {
  try {
    const resp = await api.get(`/lotes/evento/${eventoId}/all`);
    return resp.data;
  } catch (error) {
    throw new Error("Falha na comunicação com o servidor");
  }
}

// Editar os dados do lote
export async function editLoteEvento(lote: IEditLoteEvento): Promise<ILotes[]> {
  try {
    const response = await api.put("/lotes", lote);
    return response.data;
  } catch (error) {
    throw new Error("Falha na comunicação com o servidor");
  }
}

// TAGS: IMPLEMENTAÇÕES TAGS DO LOTE DO EVENTO

// Salvar uma nova TAG do evento
export async function saveTagLoteEvento(
  tag: ICreateTagLote
): Promise<ILotes[]> {
  try {
    const response = await api.post("/lotes/tags", tag);
    return response.data;
  } catch (error) {
    throw new Error("Falha na comunicação com o servidor");
  }
}

// Excluir uma TAG do lote do evento
export async function deleteTagLoteEvento(
  tagId: number,
  eventoId: number
): Promise<ILotes[]> {
  try {
    const response = await api.delete(`/lotes/tag/${tagId}`, {
      data: { eventoId },
    });
    if (response.status !== 200) {
      throw new Error(response.data?.message || "Não foi possível excluir a tag do lote.");
    }
    return response.data;
  } catch (error: any) {
    throw new Error(error.message || "Falha na comunicação com o servidor");
  }
}

// Editar a TAG do lote do evento
export async function editTagLoteEvento(tag: TagLote): Promise<ILotes[]> {
  try {
    const response = await api.put("/lotes/tag", tag);
    return response.data;
  } catch (error) {
    throw new Error("Falha na comunicação com o servidor");
  }
}
